import { ComponentType } from 'react';
import { GuardedComponents } from '../lib/permissions/types';

export type Resources = ResourceDefinition[];

export interface ResourceDefinition {
  hideInNav?: boolean;
  superAdminOnly?: boolean;
  permissionResource: string;
  name: string;
  icon?: ComponentType<any>;
  components: GuardedComponents;
  i18n?: Record<string, ResourceI18n>;
}

interface ResourceI18n extends Record<string, any> {
  name: string;
  fields: Record<string, any>;
  tabs?: Record<string, any>;
}

export interface Variant {
  id: string
  variant: string
  unit: 'Unknown' | 'PricePer100' | 'PricePer1000 '
}

export interface Product {
  name: string
  variants: Variant[]
}

export const units = [
    { id: 'Unknown', name: 'Geen / onbekend' },
    { id: 'PricePer100', name: 'Prijs per 100kg' },
    { id: 'PricePer1000', name: 'Prijs per 1000kg' },
]